import styled from "@emotion/styled";
import { theme } from "@styles/theme";
import ButtonComponent from "@components/Button";
import TextAreaComponent from "@components/form/TextArea";
import UploadIcon from "@components/icons/Upload";
import { Plus } from "@components/icons/Plus";
import { Delete } from "@components/icons/Delete";
const { sm, md, lg, xl } = theme.breakpoints;
export const Container = styled.form`
  width: 100%;
  font-size: 16px;
  margin: 3em 0;
  @media (max-width: ${xl}) {
    font-size: 11px;
  }
  @media (max-width: ${lg}) {
    font-size: 14px;
  }
`;
export const Header = styled.div`
  width: 100%;
`;
export const TypeContainer = styled.div`
  width: 35%;
  display: flex;
  @media (max-width: ${md}) {
    width: 50%;
  }
  @media (max-width: ${sm}) {
    width: 80%;
  }
`;
export const LabelCase = styled.div`
  width: 60%;
  background: white;
  color: #6d6d6d;
  font-family: "Poppins Regular";
  padding: 1.1em 0;
  text-align: center;
  border-top-left-radius: 0.75em;
  font-size: 0.8em;
`;
export const TypeCase = styled.div`
  width: 40%;
  background: ${(props: { color: string }) => props.color};
  color: white;
  font-family: "Poppins Regular";
  padding: 1.1em 0;
  border-top-right-radius: 0.75em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9em;
`;

export const TypePersonContainer = styled.div`
  display: flex;
`;
export const TypePerson = styled.div`
  cursor: pointer;
  flex-grow: 1;
  text-align: center;
  background: ${(props: { selected: boolean }) =>
    props.selected ? "#90d1f4" : "#D8DDE1"};
  color: ${(props: { selected: boolean }) =>
    props.selected ? "white" : "#6D6D6D"};
  font-family: "Poppins Regular";
  padding: 0.9em;
  :last-of-type {
    border-top-right-radius: 1em;
  }
`;
export const Body = styled.div`
  width: 100%;
  padding: 2em 3em;
  background: white;
  box-sizing: border-box;
  @media (max-width: ${xl}) {
    padding: 2em 2em;
  }
`;
export const ContainerPersons = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 2em;
`;
export const ServiceSubtitle = styled.div`
  font-size: 1em;
  font-family: "Poppins Regular";
  color: #6d6d6d;
`;
export const PlusIcon = styled(Plus)({
  marginLeft: "0.5em",
  width: "2em",
  height: "2em",
  cursor: "pointer",
});

export const DeleteIcon = styled(Delete)({
  cursor: "pointer",
  width: "1em",
  height: "1em",
});
export const TableTitle = styled.div`
  padding-right: 1em;
  font-size: 1em;
  font-family: Poppins Regular;
  color: #6d6d6d;
  @media (max-width: ${md}) {
    margin-bottom: 1em;
  }
`;
export const PillCategory = styled.div({
  color: "##707070",
  background: "white",

  borderRadius: "3vh",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  margin: "0.5em 0",
  marginRight: "1em",

  border: "#707070 solid 1px",
  padding: "5px 10px 5px",
  svg: {
    marginLeft: "0.8em",
  },
});
export const FormContainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${md}) {
    justify-content: center;
    flex-direction: column;
  }
`;
export const FormGroup = styled.div`
  position: relative;
  width: 65%;
  @media (max-width: ${md}) {
    width: 100%;
  }
`;
export const TextArea = styled(TextAreaComponent)`
  background-color: white;
  width: 100%;
  margin: 0;
  height: 12em;
  border: #707070 solid 0.5px;
  padding: 1em;
  text-align: left;
  @media (max-width: ${xl}) {
    height: 10em;
  }
  box-sizing: border-box;
`;
export const UploadContainer = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
  margin-right: 2em;
  @media (max-width: ${lg}) {
    margin-right: 0;
  }
  @media (max-width: ${md}) {
    margin: 0;
    margin-top: 2em;
  }
`;
export const Description = styled.div`
  margin: 0 2em;
  width: 20ch;
  @media (max-width: ${sm}) {
    margin: 0;
    margin-right: 1em;
  }
`;
export const Label = styled.div`
  font-size: 1.1em;
  font-family: Poppins Regular;
  margin-bottom: 0.8em;
`;
export const Detail = styled.div`
  font-family: Poppins Ligth;
  font-size: 0.9em;
`;
export const FileContainer = styled.div`
  width: 7em;
  height: 7em;
  padding: 0.4em;
  box-sizing: border-box;
  background-color: #00000029;
`;
export const File = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  border: #707070 dashed 2px;
  height: 96%;
  cursor: pointer;
`;
export const Upload = styled(UploadIcon)`
  width: 2.5em;
`;
/*export const Fotter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 2em;
  @media (max-width: ${lg}) {
    flex-wrap: wrap;
  }
`;
export const Instruction = styled.div`
  width: 46%;
  text-align: center;
  font-family: Poppins Ligth;
  font-size: 0.7em;
  color: #90d1f4;
  @media (max-width: ${md}) {
    width: 100%;
    margin-bottom: 2em;
  }
`;
export const CurrentStep = styled.div`
  padding: 0 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Poppins Ligth;
  color: #0085c8;
`;
export const Loading = styled.div`
  width: 7em;
  height: 0.5em;
  background-color: #e5e5e5;
`;
export const CurrentState = styled.div`
  width: 100%;
  background: #0085c8;
  height: 100%;
  border-radius: 0.5em;
`;
export const Button = styled(ButtonComponent)`
  margin: 0 2em;
  border-radius: 0.5em;
  padding: 0.5em 1em;
  @media (max-width: ${lg}) {
    margin-right: 0;
  }
`;*/
export const Fotter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 3em;
  @media (max-width: ${lg}) {
    flex-wrap: wrap;
  }
`;
export const Instruction = styled.div`
  width: 46%;
  text-align: center;
  font-family: Poppins Ligth;
  font-size: 0.7em;
  color: #90d1f4;
  margin-right: 10px;
  @media (max-width: ${lg}) {
    width: 100%;
    margin-bottom: 2.5em;
  }
`;
export const CurrentStep = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Poppins Ligth;
  color: #0085c8;
  margin-right: 1em;
`;
export const Loading = styled.div`
  width: 7em;
  height: 0.5em;
  background-color: #e5e5e5;
`;
export const CurrentState = styled.div`
  width: 100%;
  background: #0085c8;
  height: 100%;
  border-radius: 0.5em;
`;
export const Button = styled(ButtonComponent)`
  margin: 0 2em;
  border-radius: 0.5em;
  padding: 0.5em 1em;
  @media (max-width: ${lg}) {
    margin-right: 0;
  }
  @media (max-width: ${sm}) {
    margin-top: 2em;
  }
`;
export const Line = styled.div`
  display: none;
  width: 100%;
  height: 1px;
  background-color: #d4d4d4;
  margin-bottom: 2em;
  @media (max-width: ${md}) {
    display: block;
  }
`;
